import styled from "styled-components";
import { ButtonCopy } from "../common";

export const CheatCodeItem = styled(ButtonCopy)`
    white-space: normal;
    text-align: left;
    max-width: 600px;
`;

export const CheatCodesContainer = styled.div``;